import {
    type IPanelTheme,
    DEFAULT_COLLAPSIBLE_PANEL_THEME,
} from "app/pages/sales-intelligence/common-components/collapsible-panel";
import { AI_GRADIENT_SOFT } from "app/pages/sales-intelligence/modules/ai-agent/components";

import type { FilterModeType } from "../../types/misc";

const AI_AGENT_PANEL_THEME: IPanelTheme = {
    ...DEFAULT_COLLAPSIBLE_PANEL_THEME,
    background: AI_GRADIENT_SOFT,
    collapsedBackground: AI_GRADIENT_SOFT,
};

export const createFiltersPanelTheme = (filterMode: FilterModeType): IPanelTheme => {
    switch (filterMode) {
        case "ai-agent":
            return AI_AGENT_PANEL_THEME;

        case "filters-list":
        default:
            return DEFAULT_COLLAPSIBLE_PANEL_THEME;
    }
};
